import "./App.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { faGoogle, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ScrollspyNav from "react-scrollspy-nav";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import ListGroup from "react-bootstrap/ListGroup";
import googlecloud from "./google-cloud.svg";

function App() {
  return (
    <div>
      <Container fluid="xs">
        <Stack
          gap={3}
          className="row vh-100 justify-content-center align-items-center"
        >
          <Row className="justify-content-center">
            <Col md={8} xs={12}>
              <Card>
                <Card.Body>
                  <Card.Title>Hello!</Card.Title>
                  <Card.Text>
                    <p>I'm Ozan Özkan. As the <strong>Data &amp; ML Team Lead</strong> at Global IT International, a <strong>Google Cloud Premier Partner</strong>, I have the privilege of leading a specialized team of experts dedicated to data-driven innovation.</p>

<p>Our core mission is to empower our <strong>Google Cloud customers</strong> to unlock the full potential of their data ecosystems. My strategic approach is profoundly influenced by my <strong>'Generative AI Leader' certification</strong>, which allows me to guide clients through the complexities of this new technological frontier. We move beyond traditional analytics to architect next-generation AI solutions that drive significant innovation and create new engines for business growth.</p>

<p>My technical expertise is centered on the comprehensive <strong>Google Vertex AI platform</strong>. I have a particular focus on designing sophisticated <strong>intelligent search and discovery solutions using Vertex AI Search</strong>. This technology is key to transforming how organizations interact with their vast internal knowledge bases, enabling them to surface precise, context-aware insights instantly and create more intuitive user experiences for both their employees and customers.</p>

<p>This advanced AI strategy is built upon a robust foundation of <strong>other Google Cloud services</strong>. We leverage BigQuery not just for large-scale analytics, but as the critical data engine that powers and grounds our generative models. For deployment, we utilize efficient, serverless technologies like Cloud Run to ensure the solutions we deliver are not only powerful but also highly scalable and cost-effective, ready to meet real-world demand.</p>

<p>Ultimately, my goal at Global IT International is to unite team leadership with deep expertise in Generative AI and the broader Google Cloud ecosystem. By doing so, we deliver truly transformative outcomes that provide our customers with a lasting competitive advantage.</p>
                  </Card.Text>
                  <ListGroup variant="flush">
                    <ListGroup.Item>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.linkedin.com/in/oznozkan/"
                        className="text-decoration-none align-items-center"
                      >
                        <FontAwesomeIcon
                          icon={faLinkedin}
                          size="1x"
                          fixedWidth
                          style={{ color: "#0a66c2" }}
                        />{" "}
                        LinkedIn Profile
                      </a>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.credly.com/users/ozanozkan"
                        className="text-decoration-none align-items-center"
                      >
                        <img
                          src={googlecloud}
                          className="fa-fw fa-1x"
                          alt="google cloud"
                        />{" "}
                        Certificates
                      </a>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://partner.cloudskillsboost.google/public_profiles/74cd4e1e-80d4-4e43-a603-d0e0044467c4"
                        className="text-decoration-none align-items-center"
                      >
                        <img
                          src={googlecloud}
                          className="fa-fw fa-1x"
                          alt="google cloud"
                        />{" "}
                        Cloud Skills Profile
                      </a>
                    </ListGroup.Item>
                  </ListGroup>
                </Card.Body>
                <ListGroup className="list-group-flush"></ListGroup>
                <Card.Body>
                  <Card.Link className="text-decoration-none align-items-center" href="mailto:ozan@ozanozkan.dev">
                    <FontAwesomeIcon icon={faEnvelope} size="1x" fixedWidth />
                    Contact Me
                  </Card.Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Stack>
      </Container>
    </div>
  );
}

export default App;
